import React from "react";

const ErrorMessage = () => (
  <h6 style={{ color: "red" }}>Oops ! Something went wrong</h6>
);

export default ErrorMessage;
